import { useEffect, useRef, useState } from 'react';
import type { CSSProperties } from 'react';
import type { GameModuleProps } from '../types/game';

function shuffled(size: number): number[] {
  const values = Array.from({ length: size * size }, (_, index) => index);
  do { values.sort(() => Math.random() - 0.5); } while (values.every((value, index) => value === index));
  return values;
}

export function PhotoPuzzleModule({ module, onComplete }: GameModuleProps<'photo-puzzle'>) {
  const size = Math.min(4, Math.max(2, module.config.size ?? 3));
  const [tiles, setTiles] = useState(() => shuffled(size));
  const [selected, setSelected] = useState<number | null>(null);
  const [attempts, setAttempts] = useState(0);
  const completed = useRef(false);
  const solved = tiles.every((value, index) => value === index);

  useEffect(() => {
    if (solved && !completed.current) {
      completed.current = true;
      window.setTimeout(() => onComplete({ success: true, attempts }), 650);
    }
  }, [attempts, onComplete, solved]);

  const select = (position: number) => {
    if (selected === null) { setSelected(position); return; }
    if (selected === position) { setSelected(null); return; }
    setTiles((current) => {
      const next = [...current];
      const first = next[selected];
      const second = next[position];
      if (first === undefined || second === undefined) return current;
      next[selected] = second;
      next[position] = first;
      return next;
    });
    setAttempts((value) => value + 1);
    setSelected(null);
  };

  return (
    <div className="module-content">
      <p className="module-instruction">Elegí dos piezas para intercambiarlas.</p>
      <div className="puzzle-grid" style={{ '--size': size, aspectRatio: '1' } as CSSProperties}>
        {tiles.map((tile, position) => {
          const x = tile % size;
          const y = Math.floor(tile / size);
          const backgroundPosition = size === 1 ? '0 0' : `${(x / (size - 1)) * 100}% ${(y / (size - 1)) * 100}%`;
          return <button aria-label={`Pieza ${position + 1}`} className={`puzzle-tile ${selected === position ? 'is-selected' : ''}`}
            key={tile} onClick={() => select(position)} style={{ backgroundImage: `url(${module.config.image})`, backgroundPosition, backgroundSize: `${size * 100}% ${size * 100}%`, backgroundRepeat: 'no-repeat' }} />;
        })}
      </div>
      <p className="attempts">Movimientos: {attempts}</p>
    </div>
  );
}
